module.exports = __webpack_public_path__ + "static/img/guide.52a098d7.svg";